import { useParams } from 'react-router';
import { useObservableState } from 'observable-hooks';
import Deal from '../../../../interfaces/deal';
import RecycleDeal from '../../../../interfaces/recycle-deal';
import { useService } from '../../../../services/services';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import DealType from '../../../../enums/deal-type';
import moment from 'moment';
import { ProductObtainType } from '../../../../enums/product-obtain-type';
import { emptySelectOption } from '../../../../components/form/elements/select';
import { DefaultFormats } from '../../../../enums/default-formats';
import DealTypes from '../../../../enums/deal-type';

export function useDealState(dealType: DealType) {
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { dealService } = useService();

  const [dealState] = useObservableState<Deal | RecycleDeal>(() => {
    if (id) {
      return dealService.show(farmId, id).pipe(
        map((value: Deal | RecycleDeal) => {
          if ('data' in value) {
            return {
              ...defaultState(dealType),
              ...value.data,
            };
          } else {
            return {
              ...defaultState(dealType),
              ...value,
            };
          }
        })
      );
    } else {
      return of(defaultState(dealType));
    }
  }, null);

  return dealState;
}

export function defaultState(dealType: DealType): Deal | RecycleDeal {
  const date = moment().toDate().toLocaleDateString(DefaultFormats.DATE_FILTER);
  if (dealType === DealType.recycled) {
    const state = {
      type: { label: `classifiers.${dealType}`, value: dealType },
      date: date,
      comment: '',
      lost_products: [],
      gained_products: [],
    } as RecycleDeal;

    return state;
  } else {
    const baseState = {
      type: { label: `classifiers.${dealType}`, value: dealType },
      date: date,
      partner_id: emptySelectOption,
      comment: '',
      purchase_document_number: '',
      product_obtain_type_id: ProductObtainType.PURCHASED,
      products: [],
    } as unknown as Deal;

    switch (dealType) {
      case DealType.produced:
        baseState.product_obtain_type_id = ProductObtainType.PRODUCED;
        break;
      case DealType.purchased:
        break;
      case DealType.sold:
        break;
      case DealType.spent:
        break;
      case DealType.lost:
        baseState.subtype = DealTypes.lost;
        break;
      case DealType.self_consumed:
        break;
    }

    return baseState;
  }
}
